export default __webpack_public_path__ + "media/images/85-cabfc684f53a7293d935aa22a882b13f.jpg";